/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextEntityAttribute } from "cms/entity/entity-attributes/entity-text/entity-text";
import { FileEntityAttribute } from "cms/entity/entity-attributes/entity-file/entity-file";
import { DateEntityAttribute } from "cms/entity/entity-attributes/entity-date/entity-date";
import { TimeEntityAttribute } from "cms/entity/entity-attributes/entity-time/entity-time";
import { DateTimeEntityAttribute } from "cms/entity/entity-attributes/entity-datetime/entity-datetime";
import { SelectEntityAttribute } from "cms/entity/entity-attributes/entity-select/entity-select";
import { NumberEntityAttribute } from "cms/entity/entity-attributes/entity-number/entity-number";

export const getEntityAttribute = (type) => {
    const parts = type.split(":");
    const baseType = parts[0];
    const subType = parts[1];
    const hasSubType = !!subType;
    let editorType = baseType;
    if (hasSubType) {
        editorType = subType;
    }
    // const isList = baseType === "array";

    const views = {
        "date": DateEntityAttribute,
        "time": TimeEntityAttribute,
        "datetime": DateTimeEntityAttribute,
        "text": TextEntityAttribute,
        "select": SelectEntityAttribute,
        "number": NumberEntityAttribute,
        "file": FileEntityAttribute,

        "email": TextEntityAttribute,
        "phone": TextEntityAttribute,
        "address": TextEntityAttribute,
    };

    const view = views[editorType];
    return view;
};
    
